<div class="relative w-full rounded-xl overflow-hidden bg-white hero-banner-container" appFadeInOnScroll>
  <div class="hero-banner absolute w-full h-full">
    <div class="mask absolute w-full h-full top-0 left-0"></div>
  </div>
  <div class="bottom-1/4 py-24 lg:py-48 relative grid md:grid-cols-2 grid-cols-1 md:left-10 md:text-left text-center">
    <div>
        <h2 class="text-normal text-20 md:text-60 font-bold" i18n>
            Turn Your Name Into a Brand
        </h2>
        <p class="text-light text-md md:text-md leading-2 font-light mt-4 text-wrap overflow-hidden"  i18n>
            Turn your followers into customers. Launch your brand shop in just minutes, with your logo on products as a brand. Make your name unforgettable with Brandomize!
        </p>
    </div>
    <div class="flex justify-around items-end">
        <app-primary-button className="w-full mt-10 md:mt-0 md:w-64 leading-6 block text-center !text-xl" [link]="'/onboarding/ru'" [text]="'Create your brand'"></app-primary-button>
    </div>
  </div>
</div>
